import { render, staticRenderFns } from "./Profiluser.vue?vue&type=template&id=88460150"
import script from "./Profiluser.vue?vue&type=script&lang=js"
export * from "./Profiluser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports